<chips-v2
  [items]="items"
  [initial]="initial"
  [attr.data-id]="field.key"
  [placeholder]="props.label || ''"
  (itemSelectionChanged)="select($event)"
/>
